import { createTheme } from '@mui/material';
import { breakpoints } from './breakpoints';
import colors from './colors';
import components from './muiOverrides';
import typography from './typography';
import radius from './radius';

const theme = createTheme({
  ...colors,
  ...typography,
  ...components,
  ...radius,
  breakpoints: {
    values: {
      xs: 400,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export { theme, breakpoints };
